<!-- app.component.html -->
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container">
  <a class="navbar-brand" routerLink="/">
    <img src="assets/img/home-1/8.png" alt="Logo">
  </a>
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav"  style="padding-left: 20px; list-style: none;">
      <li class="nav-item">
        <a class="nav-link" routerLink="/" routerLinkActive="active">Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/job-list" routerLinkActive="active">Vakaturanan</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/stage" routerLinkActive="active">Stage</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/upload-cv" routerLinkActive="active" *ngIf="isLoggedIn();">Upload CV</a>
      </li>
    </ul>
    <div class="common-btn" *ngIf="!isLoggedIn(); else loggedInTemplate">
      <a class="login-btn" routerLink="/login"><i class="icofont-plus-square"></i> Login</a>
      <a class="sign-up-btn" routerLink="/create-account"><i class="icofont-user-alt-4"></i> Registrá</a>
    </div>
    
    <ng-template #loggedInTemplate>
      <div class="common-btn">
        <a *ngIf="isLoadingProfile" class="login-btn" routerLink="/dashboard"><div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div></a>
        <a *ngIf="!isLoadingProfile" class="login-btn" routerLink="/dashboard"><i class="icofont-user-alt-4"></i> {{ userInfo?.firstname }} {{ userInfo?.lastname }}</a>
        <a class="sign-up-btn" (click)="signOut()"><i class="icofont-logout"></i> Sign Out</a>
      </div>
    </ng-template>

  </div>
  
                   
                    
                    
</div>
</nav>
